export { default } from './Rassrochka';
